<template>
    <v-app id="app">
        <HeaderSuperior
            :esMovil="esMovil"
            :enlacesDesktop="enlacesDesktop"
            @activarDrawer="drawer = true"
        >
        </HeaderSuperior>

        <MenuLateral
            :drawer="drawer"
            :esMovil="esMovil"
            :enlacesMovil="enlacesMovil"
            :enlacesObjetivos="enlacesObjetivos"
            @cambiarDrawner="drawer = $event"
        >
        </MenuLateral>
        <v-main>
            <router-view></router-view>
        </v-main>
        <FooterDesktop :esMovil="esMovil"> </FooterDesktop>
        <FooterMovil v-if="esMovil" :enlacesMovil="enlacesMovil"></FooterMovil>
        <BannerCookies></BannerCookies>
    </v-app>
</template>
<script>
import MasterdataService from "@services/MasterdataService";
import BannerCookies from "@components/BannerCookies";
import MenuLateral from "@layouts/MenuLateral.vue";
import HeaderSuperior from "@layouts/HeaderSuperior.vue";
import FooterMovil from "@layouts/FooterMovil.vue";
import FooterDesktop from "@layouts/FooterDesktop.vue";

export default {
    name: "Layout",
    components: {
        BannerCookies,
        MenuLateral,
        HeaderSuperior,
        FooterMovil,
        FooterDesktop,
    },
    data: function () {
        return {
            drawer: false,
            enlacesDesktop: [
                {
                    icono: "fa-house",
                    texto: this.$t("layout.enlaces.inicio"),
                    link: { name: "inicio" },
                },
                {
                    icono: "fa-list",
                    texto: this.$t("layout.enlaces.indicadores"),
                    link: { name: "listado-indicadores" },
                },
                {
                    icono: "fa-solid fa-bookmark",
                    texto: this.$t("layout.enlaces.favoritos"),
                    link: { name: "favoritos" },
                },
                {
                    icono: "fa-solid fa-chart-bar",
                    texto: this.$t("layout.enlaces.estado_agenda"),
                    link: { name: "estado-agenda" },
                },
            ],
            enlacesMovil: [
                {
                    icono: "fa-house",
                    texto: this.$t("layout.enlaces.inicio"),
                    link: { name: "inicio" },
                },
                {
                    icono: "fa-solid fa-chart-bar",
                    texto: this.$t("layout.enlaces.estado_agenda"),
                    link: { name: "estado-agenda" },
                },
                {
                    icono: "fa-list",
                    texto: this.$t("layout.enlaces.listado-indicadores"),
                    link: { name: "listado-indicadores" },
                },
                {
                    icono: "fa-magnifying-glass",
                    texto: this.$t("layout.enlaces.buscar"),
                    link: "#",
                },
                {
                    icono: "fa-bookmark",
                    texto: this.$t("layout.enlaces.favoritos"),
                    link: { name: "favoritos" },
                },
            ],
            enlacesObjetivos: [],
        };
    },
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
    mounted() {
        MasterdataService.getEnlacesObjetivos().then((response) => {
            this.enlacesObjetivos = response.data.objetivos.map((objetivo) => ({
                ...objetivo,
                texto: this.$t(objetivo.texto),
            }));
        });
    },
};
</script>
<style scoped>
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 20px;
    align-self: center;
}

.v-btn--active.sin-brillo::before {
    opacity: 0 !important;
}

.v-list-item--active.sin-brillo::before {
    opacity: 0 !important;
}

.v-list-item__content {
    font-size: 0.85em;
    font-weight: bold;
    color: #263676;
}

.theme--light.v-subheader {
    font-size: 0.85em;
    font-weight: 800;
    color: #263676;
}
</style>
